import gql from 'graphql-tag';

const GET_PAYMENT_CARD_INFO = gql`query getOrderPaymentInfo($numOrder: String) {
    getOrderPaymentInfo(numOrder: $numOrder) {
      card {
        lastDigits
        brand
      }
    }
}`;

export default GET_PAYMENT_CARD_INFO;
